// extracted by mini-css-extract-plugin
export default {"seriesFilter":"SeriesFilter_seriesFilter__MHm3n","seriesSelect":"SeriesFilter_seriesSelect__qjSuX","selectArrow":"SeriesFilter_selectArrow__IVdG1"};